import styled from 'styled-components';

export const Container = styled.div`
  cursor: move;
  padding: 5px 0;
  padding-top: ${({ addPaddingTop }) => (addPaddingTop) && '50px'};
  padding-bottom: ${({ addPaddingBottom }) => (addPaddingBottom) && '50px'};
  transition: 0.2s;
  display: ${({ isDragging }) => isDragging && 'none'};
`;

export const ContainerInside = styled.div`
  background-color: #FFF;
  display: flex;
  height: min-content;
  border-radius: 2px;
`;
